import type { Module } from 'vuex';
import { LanguagePage } from '@/types/LanguagePage';
import {RootState} from "@/store";

export interface LanguagePageState {
  languagePage: LanguagePage | null;
  deleted: boolean;
}

const languagePageModule: Module<LanguagePageState, RootState> = {
  namespaced: true,
  state: (): LanguagePageState => ({
    languagePage: null,
    deleted: false,
  }),
  mutations: {
    setLanguagePage(state, payload: any) {
      if (payload === null) {
        state.languagePage = null;
        state.deleted = false;
        return;
      }
      state.languagePage = LanguagePage.fromRaw(payload);
      state.deleted = false;
    },
    setLanguagePageUpdate(state, payload: any) {
      if (!state.languagePage || state.languagePage.idLanguagePage !== payload.idLanguagePage) return;
      if (payload.name !== undefined) state.languagePage.name = payload.name;
      if (payload.orphan !== undefined) state.languagePage.orphan = payload.orphan;
    },
    setLanguagePageDelete(state, payload: { idLanguagePage: number }) {
      if (state.languagePage?.idLanguagePage === payload.idLanguagePage) {
        state.deleted = true;
      }
    },
    clearLanguagePage(state) {
      state.languagePage = null;
      state.deleted = false;
    },
  },
  actions: {
    wsSetLanguagePage({ commit }, payload) {
      commit('setLanguagePage', payload);
    },
    wsSetEmptyLanguagePage({ commit }) {
      commit('setLanguagePage', null);
    },
    wsLanguagePageUpdate({ commit }, payload) {
      commit('setLanguagePageUpdate', payload);
    },
    wsLanguagePageDelete({ commit }, payload) {
      commit('setLanguagePageDelete', payload);
    },
    clearLanguagePage({ commit }) {
      commit('clearLanguagePage');
    },
  },
};

export default languagePageModule;
